import { render, staticRenderFns } from "./OrganizationAdd.vue?vue&type=template&id=30e17942&"
import script from "./OrganizationAdd.vue?vue&type=script&lang=js&"
export * from "./OrganizationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports